module.exports = __webpack_public_path__ + "static/media/slide1.ee35b7a4.png";